module.exports = __webpack_public_path__ + "444dee62a90cf29c18b1fd0c45ab4249.png";